import { useCallback, useEffect, useMemo, useRef } from "react";
import { useAtom } from "jotai";
import { v4 as uuidv4 } from 'uuid';
import syncFormKeyAtom from "@/atom/syncFormKey";


export const useSyncForm = (syncCallback?: () => void) => {
    const [syncKey, setSyncKey] = useAtom(syncFormKeyAtom);
    const prevSyncKeyRef = useRef<string>(syncKey);
    const callbackRef = useRef(syncCallback);

    const sync = useCallback(() => {
        setSyncKey(uuidv4());
    }, [setSyncKey]);

    useEffect(() => {
        callbackRef.current = syncCallback;
    }, [syncCallback]);

    useEffect(() => {
        if (prevSyncKeyRef.current !== syncKey) {
            prevSyncKeyRef.current = syncKey;
            callbackRef.current?.();
        }
    }, [syncKey]);

    return useMemo(() => {
        return { syncForm: sync };
    }, [sync]);
};
